export const SolicitacoesStore = {
    namespaced: true,
    state : {
        FiltroSolicitacoes: {},
    },
    mutations : {
    },
    actions : {
    },
    getters : {
        FiltroSolicitacoes: (state, getters) => {
            return state.FiltroSolicitacoes;
        },   
    }
}